import React from "react";
import ArcadeEmbed from "./ArcadeEmbed";

const TakeTheTour = () => {
  return (
    <section className="pt-16 pb-8  2xl:h-[calc(100vh-96px)] h-[calc(100vh-75px)] md:pb-[6rem] w-full flex flex-col items-center justify-center px-5 md:px-24 bg-white snap-start transition-all duration-700">
      <div className="w-full flex flex-col justify-center items-center pb-24 md:pb-0 text-center md:max-w-7xl 2xl:max-w-[90%] h-full md:h-auto">
        <h2 className="text-xl md:text-3xl font-semibold text-gray-800 mb-6 md:mb-12">
          Take the tour
        </h2>
        <ArcadeEmbed />
      </div>
    </section>
  );
};

export default TakeTheTour;
